function equalSize(group, type) {
    group.each(function(){ $(this).css(type, ''); });
    let biggest = 0;

    group.each(function() {
        let thisSize = (type === 'height') ? $(this).height() : $(this).width();
        if(thisSize > biggest) {
            biggest = thisSize;
        }
    });

    group.each(function() {
      if (type === 'height') {
        $(this).height(biggest);
      } else {
        $(this).width(biggest);
      }
    });
}

function setupEqualSizeGroup(group, type) {
    $(window).on('resize eq-h-should-resize', function(){
        equalSize(group, type);
    });

    equalSize(group, type);
}

$(() => {
    $('[data-eq-h-id]').each(function(){
        setupEqualSizeGroup($("[data-eq-h-id='" + $(this).data('eq-h-id') + "']"), 'height');
    });

    $('[data-eq-w-id]').each(function(){
        setupEqualSizeGroup($("[data-eq-w-id='" + $(this).data('eq-w-id') + "']"), 'width');
    });
});
